module.exports = __webpack_public_path__ + "img/3-3.e10d6eaf.png";